module.exports = __webpack_public_path__ + "static/media/star-of-life.0d5c0d74.svg";